import apiService from "../api/api.service.js";

export default {
  data() {
    return {
      loaded: false,
      loinfo: null,
      reviews: [],
      realtor: null,
      larFromQuery: "",
      ridFromQuery: "",
      include_inactive: false,
      load_error: ""
    };
  },
  computed: {
    loName() {
      if (!this.loinfo) return "";
      return (this.loinfo.first_name || "") + " " + (this.loinfo.last_name || "");
    },
    loTitle() {
      if (!this.loinfo) return "";
      return this.loinfo.title || "";
    },
    realtorName() {
      if (!this.realtor) return "";
      return (this.realtor.first_name || "") + " " + (this.realtor.last_name || "");
    },
    hasSocial() {
      if (!this.loinfo) return false;
      return !!(this.loinfo.facebook_link || this.loinfo.linkedin_link || this.loinfo.zillow_link);
    },
    applyLeftLink() {
      if (!this.loinfo) return "";
      return this.appendBranding("");
    },
    applyRightLink() {
      if (!this.loinfo) return "";
      return this.appendBranding(this.loinfo.header_link);
    }
  },
  methods: {
    readQuery() {
      const p = new URLSearchParams(window.location.search);
      this.larFromQuery = p.get("lar") || "";
      this.ridFromQuery = p.get("rid") || "";
      const inc = (p.get("include_inactive") || "").toLowerCase();
      this.include_inactive = inc === "1" || inc === "true" || inc === "yes";
    },
   appendBranding(link) {
  if (!link) return "";

  const host = (window.location.hostname || "").toLowerCase();
  const isDev =
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "::1" ||
    host.includes("dev");

  const baseOrigin = isDev
    ? "https://dev-apply.loanlaunch.com"
    : "https://apply.loanlaunch.com";

  const u = new URL(baseOrigin);

  if (this.larFromQuery) u.searchParams.set("lar", this.larFromQuery);
  if (this.ridFromQuery) u.searchParams.set("rid", this.ridFromQuery);

  return u.toString();
},
    async loadLo() {
      if (!this.larFromQuery) return;
      const res = await apiService.GetLOPage(this.larFromQuery);
      this.loinfo = res.data.data && res.data.data.length ? res.data.data[0] : null;

      if (this.loinfo) {
        document.title =
          (this.loinfo.first_name || "") +
          " " +
          (this.loinfo.last_name || "") +
          (this.loinfo.nmls ? " " + this.loinfo.nmls : "");
      }
    },
    async loadReviews() {
      if (!this.loinfo || !this.loinfo.azure_ID) return;
      const rr = await apiService.GetReviews(this.loinfo.azure_ID);
      this.reviews = rr.data.data || [];
    },
    async loadRealtor() {
      if (!this.ridFromQuery) {
        this.realtor = null;
        return;
      }

      const res = await apiService.GetRealtorPartner(this.ridFromQuery, this.include_inactive);
      this.realtor = res.data.data && res.data.data.length ? res.data.data[0] : null;
    }
  },
  async mounted() {
    this.readQuery();

    try {
      await Promise.all([this.loadLo(), this.loadRealtor()]);
      await this.loadReviews();
    } catch (e) {
      this.load_error = e && e.message ? e.message : String(e);
      console.log(e);
    } finally {
      this.loaded = true;
    }
  }
};